import DashboardIcon from "@mui/icons-material/Dashboard";
import ReportIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleIcon from "@mui/icons-material/People";
import CategoryIcon from "@mui/icons-material/Category";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import ArticleIcon from "@mui/icons-material/Article";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CallIcon from "@mui/icons-material/Call";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SchoolIcon from "@mui/icons-material/School";
import FeedbackIcon from "@mui/icons-material/Feedback";
import ListAltIcon from "@mui/icons-material/ListAlt";

export const menuItems = {
  // Nested menus
  reports: {
    id: 'reports',
    label: 'Reports',
    icon: ReportIcon,
    permissions: ['admin', 'operater', 'manager'],
    children: [
      // {
      //   id: 'overall',
      //   label: 'Overall Report',
      //   href: '/#/reports/overall'
      // },

      // {
      //   id: 'orders',
      //   label: 'Orders Report',
      //   href: '/#/reports/orders'
      // },
      // {
      //   id: 'services',
      //   label: 'Service Report',
      //   href: '/#/reports/services'
      // },
      // {
      //   id: 'offers',
      //   label: 'Offers Report',
      //   href: '/#/reports/offers'
      // },
      // {
      //   id: 'inputs',
      //   label: 'Inputs Report',
      //   href: '/#/reports/inputs'
      // },
      {
        id: 'overview',
        label: 'Overview Report',
        href: '/#/reports/overview'
      },
      {
        id: 'contribution-offers',
        label: 'Contribution Offers',
        href: '/#/reports/thabat-offers'
      },
      {
        id: 'contribution-requests',
        label: 'Contribution Requests',
        href: '/#/reports/thabat-requests'
      },
      {
        id: 'inkind-shipments',
        label: 'Contribution Orders',
        href: '/#/reports/in-kind-orders'
      },
      {
        id: 'offers',
        label: 'Offers Report',
        href: '/#/reports/teerab-offers'
      },
      {
        id: 'requests',
        label: 'Requests Report',
        href: '/#/reports/teerab-requests'
      },
      {
        id: 'orders',
        label: 'Orders Report',
        href: '/#/reports/teerab-orders'
      },

      // {
      //   id: 'orders',
      //   label: 'Orders Report',
      //   href: '/#/reports/orders'
      // },
      // {
      //   id: 'services',
      //   label: 'Service Report',
      //   href: '/#/reports/services'
      // },
      // {
      //   id: 'offers',
      //   label: 'Offers Report',
      //   href: '/#/reports/offers'
      // },
      // {
      //   id: 'inputs',
      //   label: 'Inputs Report',
      //   href: '/#/reports/inputs'
      // },
      {
        id: 'users',
        label: 'Users Report',
        href: '/#/reports/users'
      },
      {
        id: 'sms-delivery-reports',
        label: 'SMS Log',
        href: '/#/sms-delivery-reports'
      },
      {
        id: 'calls',
        label: 'Call Reports',
        href: '/#/reports/calls',
        permissions: ['admin', 'operater', 'manager']
      },
      // Thabat Inkind submenu
      // {
      //   id: 'thabat-inkind',
      //   label: 'Thabat Inkind',
      //   children: [
      //     {
      //       id: 'inkind-crops',
      //       label: 'Crops',
      //       href: '/#/reports/in-kind-offers'
      //     },
      //     {
      //       id: 'inkind-services',
      //       label: 'Services',
      //       href: '/#/reports/in-kind-services'
      //     },
      //     {
      //       id: 'inkind-shipments',
      //       label: 'Shipments',
      //       href: '/#/reports/in-kind-orders'
      //     }
      //   ]
      // }
    ]
  },
  // Single items
  adminsManagement: {
    id: 'admins',
    label: 'Admins Management',
    icon: AdminPanelSettingsIcon,
    href: '/#/admins',
    permissions: ['admin']
  },
  users: {
    id: 'users',
    label: 'Users',
    icon: PeopleIcon,
    href: '/#/users',
    permissions: ['admin', 'operater']
  },
  beneficiaries: {
    id: 'beneficiaries',
    label: 'Beneficiaries',
    icon: PeopleIcon,
    href: '/#/beneficiaries',
    permissions: ['admin', 'operater']
  },
  biddings: {
    id: 'biddings',
    label: 'Join Requests',
    icon: HowToRegIcon,
    href: '/#/biddings',
    permissions: ['admin', 'operater']
  },
  blogs: {
    id: 'blogs',
    label: 'Blogs',
    icon: ArticleIcon,
    href: '/#/blogs',
    permissions: ['admin', 'operater']
  },
  gallery: {
    id: 'gallery',
    label: 'Gallery',
    icon: PhotoLibraryIcon,
    href: '/#/gallery',
    permissions: ['admin', 'operater']
  },
  alerts: {
    id: 'alerts',
    label: 'Alerts',
    icon: NotificationsIcon,
    href: '/#/alerts',
    permissions: ['admin', 'operater']
  },
  callRecords: {
    id: 'call-records',
    label: 'Call Records',
    icon: CallIcon,
    href: '/#/call-records',
    permissions: ['admin', 'operater']
  },
  consultations: {
    id: 'consultations',
    label: 'Consultations',
    icon: SupportAgentIcon,
    href: '/#/consultations',
    permissions: ['admin', 'operater']
  },
  knowledgemanager: {
    id: 'knowledgemanager',
    label: 'Knowledge Manager',
    icon: SchoolIcon,
    href: '/#/knowledgemanager',
    permissions: ['admin', 'operater', 'knowledgeManger']
  },
  feedbacks: {
    id: 'feedbacks',
    label: 'Feedbacks',
    icon: FeedbackIcon,
    href: '/#/feedbacks',
    permissions: ['admin', 'operater', 'manager']
  },
  invoices: {
    id: 'invoices',
    label: 'Invoices',
    icon: ListAltIcon,
    href: '/#/invoices',
    permissions: ['admin', 'operater', 'manager']
  },
  auctions: {
    id: 'auctions',
    label: 'Auctions',
    icon: LocalOfferIcon,
    href: '/#/auctions',
    permissions: ['admin', 'operater', 'supervisor']
  },
  logs: {
    id: 'logs',
    label: 'Activities Log',
    href: '/#/logs',
    permissions: ['admin', 'operater', 'manager']
  },



  categories: {
    id: 'categories',
    label: 'Categories',
    icon: CategoryIcon,
    permissions: ['admin'],
    children: [
      {
        id: 'category',
        label: 'Crop Categories',
        href: '/#/category'
      },
      {
        id: 'sub_category',
        label: 'Subcategory',
        href: '/#/sub_category'
      },
      {
        id: 'servicetypes',
        label: 'Service Types',
        href: '/#/servicetypes'
      },
      {
        id: 'inputs',
        label: 'Inputs Categories',
        href: '/#/inputs'
      },
      {
        id: 'media-categories',
        label: 'Media Categories',
        href: '/#/media-categories'
      }
    ]
  },

  transactions: {
    id: 'transactions',
    label: 'Order Flow',
    icon: ShoppingCartIcon,
    permissions: ['admin', 'operater'],
    children: [
      {
        id: 'negotiations',
        label: 'Negotiations',
        href: '/#/negotiations'
      },
      {
        id: 'invoices',
        label: 'Invoices',
        href: '/#/invoices'
      },
      {
        id: 'orders',
        label: 'Orders',
        href: '/#/orders'
      }
    ]
  },

  marketplace: {
    id: 'marketplace',
    label: 'Marketplace',
    icon: LocalOfferIcon,
    permissions: ['admin', 'operater'],
    children: [
      {
        id: 'offers',
        label: 'Crop Offers',
        href: '/#/offers'
      },
      {
        id: 'input-products',
        label: 'Input Products',
        href: '/#/input-products'
      },
      {
        id: 'services',
        label: 'Services',
        href: '/#/services'
      },
      {
        id: 'auctions',
        label: 'Auctions',
        href: '/#/auctions'
      }
    ]
  },

  location: {
    id: 'location',
    label: 'Location',
    icon: LocalOfferIcon,
    permissions: ['admin', 'operater'],
    children: [
      {
        id: 'state',
        label: 'States',
        href: '/#/state'
      },
      {
        id: 'city',
        label: 'Cities',
        href: '/#/city'
      },
      {
        id: 'locality',
        label: 'Localities',
        href: '/#/locality'
      },
    ]
  }
};

// Helper to get menu items by permission
export const getMenuItemsByPermission = (permission) => {
  const filteredItems = [];

  Object.values(menuItems).forEach(item => {
    if (item.permissions.includes(permission)) {
      filteredItems.push(item);
    }
  });

  return filteredItems;
};